"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const colors_1 = __importDefault(require("../palette/colors"));
const muiOutlinedInput = {
    styleOverrides: {
        root: {
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: colors_1.default.violet,
                borderWidth: 2,
            },
        },
    },
};
exports.default = muiOutlinedInput;
//# sourceMappingURL=muiOutlinedInput.js.map